import { CodeHighlightNode, CodeNode } from '@lexical/code';
import { HashtagNode } from '@lexical/hashtag';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { MarkNode } from '@lexical/mark';
import { OverflowNode } from '@lexical/overflow';
import { HorizontalRuleNode } from '@lexical/react/LexicalHorizontalRuleNode';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import { ImageNode } from './ImageNode';
import { MentionNode } from './MentionNode';
import { EmojiNode } from './EmojiNode';
import { KeywordNode } from './KeywordNode';
import { YouTubeNode } from './YouTubeNode';
import { ExtendedTextNode } from './ExtendedTextNode';
import { TextNode } from 'lexical';

const EditorNodes = [
  HeadingNode,
  ListNode,
  ListItemNode,
  QuoteNode,
  CodeNode,
  TableNode,
  TableCellNode,
  TableRowNode,
  HashtagNode,
  CodeHighlightNode,
  AutoLinkNode,
  LinkNode,
  OverflowNode,
  // PollNode,
  // StickyNode,
  ImageNode,
  // InlineImageNode,
  MentionNode,
  EmojiNode,
  // ExcalidrawNode,
  // EquationNode,
  // AutocompleteNode,
  KeywordNode,
  HorizontalRuleNode,
  // TweetNode,
  YouTubeNode,
  // FigmaNode,
  MarkNode,
  // CollapsibleContainerNode,
  // CollapsibleContentNode,
  // CollapsibleTitleNode,
  // PageBreakNode,
  // LayoutContainerNode,
  // LayoutItemNode,
  ExtendedTextNode,
  {
    replace: TextNode,
    with: (node) => new ExtendedTextNode(node.__text, node.__key),
  },
];

export default EditorNodes;
